import { dayjs } from '@/libs';
import { parseDigits } from '@/utils';

export const formatDate = (value: string) => {
  const numericValue = parseDigits(value);
  const numericValueLength = numericValue.length;

  if (numericValueLength > 4) {
    return `${numericValue.slice(0, 2)} / ${numericValue.slice(2, 4)} / ${numericValue.slice(4, 8)}`;
  }

  if (numericValueLength > 2) {
    return `${numericValue.slice(0, 2)} / ${numericValue.slice(2, 4)}`;
  }

  return numericValue;
};

export const formatDateTime = (iso: string): string => {
  return dayjs(iso).format('DD/MM/YYYY - HH:mm');
};
